import config from "./config";

let ip = '127.0.0.1'

export default {
    ...config,
    debug: false,
    ssl: false,
    soon: false,
    urls: {
        api: ip + ':15061',
        cdn: ip + ':15062',
        panel: ip + ':15063',
        site: ip + ':15060'
    },
    directives: {
        connectSrc: [
            ip + ":15061", ip + ":15060", ,
            "widget.getwhelp.com", "widget-api.getwhelp.com", "wss://widget-server.whelp.co",
            "analytics.google.com",
            "*.yandex.ru", "*.google-analytics.com"
        ],
        defaultSrc: [
            "cdn.getwhelp.com", "widget.getwhelp.com"
        ],
        imgSrc: [
            "blob:", ip + ":15062",
            "www.facebook.com", "connect.facebook.net",
            "img.youtube.com", "i.ytimg.com", 'www.youtube.com',
            "a.tile.osm.org", "b.tile.osm.org", "c.tile.osm.org", "api.mapbox.com",
            "widget.getwhelp.com", "cdn.getwhelp.com",
            "googleads.g.doubleclick.net", "www.google-analytics.com", "www.google.com", "www.google.az",
            "*.yandex.ru", "dummyimage.com"
        ],
        fontSrc: [
            "data:", "fonts.gstatic.com"
        ],
        frameSrc: [
            "www.youtube.com", "www.facebook.com", "bid.g.doubleclick.net"
        ],
        styleSrc: [
            "cdnjs.cloudflare.com"
        ]
    },
    google: {
        tagManagerId: '',
        analyticsId: '',
    },
    facebook: {
        pixelId: ''
    },
}
